import React from 'react'
import '../styles/About.scss';
import prof from '../images/PROF.JPG'
import { Breakpoint } from 'react-socks';



function About() {
  return (
    <div>
      <Breakpoint large up>
        <div className='about'>
          <div className='about-left'>
            <div className='about-title'>About Me</div>
            <img className='about-image' src={prof} />
          </div>
          <div className='about-right'>
            <p className='about-details'>
              Born and raised in San Francisco, I've spent the last four years in sunny Santa Cruz pursuing degree in Computer Science. I am an aspiring front end developer with an interest in cloud computing and I'm always looking for new opportunities to learn and grow.
            <br></br>
            <br></br>
            Growing up, I've always had an affinity for music, design, and creating. I loved expressing my originality in writing stories, designing websites, building LEGOs, and singing. My goal in the industry is to combine my lifelong passion for the arts with my engineering background to create elegant, efficient technological solutions for the best possible user experience.
            <br></br>
            <br></br>
            When I'm not coding away to soulful R&B, you can find me producing music, religiously checking NBA box scores, sharing my workout routines (with non-interested individuals), or reading. Feel free to contact me with opportunities or if you want to get to know me better!
            </p>
          </div>          
        </div>
      </Breakpoint>
      <Breakpoint medium down>
        <div className='about'>
          <div className='about-title'>About Me</div>
          <img className='about-image' src={prof} />
          <p className='about-details'>
          Born and raised in San Francisco, I've spent the last four years in sunny Santa Cruz pursuing degree in Computer Science. I am an aspiring front end developer with an interest in cloud computing and I'm always looking for new opportunities to learn and grow.
            <br></br>
            <br></br>
            Growing up, I've always had an affinity for music, design, and creating. I loved expressing my originality in writing stories, designing websites, building LEGOs, and singing. My goal in the industry is to combine my lifelong passion for the arts with my engineering background to create elegant, efficient technological solutions for the best possible user experience.
            <br></br>
            <br></br>
            When I'm not coding away to soulful R&B, you can find me producing music, religiously checking NBA box scores, sharing my workout routines (with non-interested individuals), or reading. Feel free to contact me with opportunities or if you want to get to know me better!          </p>
        </div>
      </Breakpoint>
    </div>
  )
}

export default About
